var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('acgn-approve-detail',{attrs:{"comicId":_vm.comicId,"userId":_vm.userId}})}
var staticRenderFns = []

export { render, staticRenderFns }